import { GridRow, Icon, Label } from "semantic-ui-react";

import { DATE_FORMATS_FNS } from "components";
import { formatDate } from "utils/dateHelperFunctions";

import type { DropdownItemProps } from "components";
import type { SNOOZE_DEPARTMENTS, SNOOZE_STATUSES, SNOOZE_TYPES, Snooze } from "models";

type InitialLogValuesProps = {
  snoozeItem: Snooze;
  snoozeTypeOptions: DropdownItemProps<SNOOZE_TYPES>[];
  snoozeStatusOptions: DropdownItemProps<SNOOZE_STATUSES>[];
  snoozeDepartmentOptions: DropdownItemProps<SNOOZE_DEPARTMENTS>[];
};

export const InitialLogValues = ({ snoozeItem, snoozeTypeOptions, snoozeStatusOptions, snoozeDepartmentOptions }: InitialLogValuesProps) => (
  <GridRow className="log_values">
    <Label>
      <Icon name="time" />
      {snoozeTypeOptions.find(type => type.key === snoozeItem.snooze_type_id)?.text}
    </Label>

    {!!snoozeItem.snooze_status_id && (
      <Label>
        <Icon name="list alternate" />
        {snoozeStatusOptions.find(type => type.key === snoozeItem.snooze_status_id)?.text}
      </Label>
    )}
    {!!snoozeItem.snooze_date && (
      <Label>
        <Icon name="calendar alternate outline" />
        {formatDate(snoozeItem.snooze_date, DATE_FORMATS_FNS.dateMonthYear)}
      </Label>
    )}
    {!!snoozeItem.snooze_department_id && (
      <Label>
        <Icon name="building" />
        {snoozeDepartmentOptions.find(type => type.key === snoozeItem.snooze_department_id)?.text}
      </Label>
    )}
  </GridRow>
);
